import Text from '@cartwhl/ui/base/Text';

export default function PlanFeatures({
  plan,
}: {
  plan: 'Creator' | 'Unlimited' | 'Professional';
}) {
  if (plan === 'Creator') {
    return (
      <div className="flex flex-col">
        <Text as="p" variant="studio/body/bold/md">
          Creator
        </Text>
        <ul className="text-gray-60 mt-2 list-disc pl-4 text-sm">
          <li>150 Spins / mo</li>
          <li>Motion Library access</li>
          <li>Video to Motion access</li>
        </ul>
      </div>
    );
  }

  if (plan === 'Unlimited') {
    return (
      <div className="flex flex-col">
        <Text as="p" variant="studio/body/bold/md">
          Unlimited
        </Text>
        <ul className="text-gray-60 mt-2 list-disc pl-4 text-sm">
          <li>Everything in Professional</li>
          <li>Unlimited Spins</li>
          <li>Advanced support</li>
        </ul>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <Text as="p" variant="studio/body/bold/md">
        Professional
      </Text>
      <ul className="text-gray-60 mt-2 list-disc pl-4 text-sm">
        <li>Everything in Creator</li>
        <li>1,500 Spins per month</li>
        <li>Export Maya w/ extended rig features</li>
      </ul>
    </div>
  );
}
